var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_145752_20447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16637 3.16636C4.65852 1.67424 6.72205 0.75 9 0.75C11.278 0.75 13.3415 1.67424 14.8336 3.16637L14.3033 3.6967L14.8336 3.16637C16.3258 4.65852 17.25 6.72205 17.25 9C17.25 11.278 16.3258 13.3415 14.8336 14.8336C13.3415 16.3258 11.278 17.25 9 17.25C6.72205 17.25 4.65852 16.3258 3.16637 14.8336L3.6967 14.3033L3.16637 14.8336C1.67424 13.3415 0.75 11.278 0.75 9C0.75 6.72205 1.67424 4.65852 3.16636 3.16637L3.16637 3.16636ZM9 2.25C7.13585 2.25 5.44938 3.0047 4.22702 4.22703C3.00469 5.44939 2.25 7.13585 2.25 9C2.25 10.8641 3.0047 12.5506 4.22703 13.773C5.44938 14.9953 7.13585 15.75 9 15.75C10.8641 15.75 12.5506 14.9953 13.773 13.773C14.9953 12.5506 15.75 10.8641 15.75 9C15.75 7.13585 14.9953 5.44938 13.773 4.22703C12.5506 3.0047 10.8641 2.25 9 2.25ZM13.2803 6.21967C13.5732 6.51256 13.5732 6.98744 13.2803 7.28033L8.78033 11.7803C8.48744 12.0732 8.01256 12.0732 7.71967 11.7803L5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967L8.25 10.1893L12.2197 6.21967C12.5126 5.92678 12.9874 5.92678 13.2803 6.21967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145752_20447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.05052ed93ae326616b98798ae333c496.svg";
export { ForwardRef as ReactComponent };